import ApiService from "@/core/services/api.service"
import { Models, Services } from "@ekkosense/predict-client-api"
import { Base } from "./Base"
import { NRef } from "@/client-store/common/NRef"

/**
 *
 */
export class PowerMeterPoint extends Base<Models.PowerMeterPointModel> {
    /**
     *
     * @returns
     */
    private getService() {
        return ApiService.getNamedService<Services.PowerMeterPointService>("PowerMeterPointService")
    }
    async add(): Promise<NRef<Models.PowerMeterPointModel>> {
        const service = await this.getService()
        const [nodeOut] = await service.addPowerMeterPoint(this.node)
        this.node = nodeOut
        await this.connect()
        return nodeOut
    }
    async connect(): Promise<any> {
        const siteConfiguration = await this.node.getSiteConfiguration()
        siteConfiguration?.addMeterPoints([this.node])
    }
    async disconnect(): Promise<any> {
        const siteConfiguration = await this.node.getSiteConfiguration()
        siteConfiguration?.removeMeterPoints([this.node])
        return this.disconnect()
    }
    async remove(): Promise<any> {
        const service = await this.getService()
        await service.removePowerMeterPoint(this.node)
    }
    async update(): Promise<any> {
        const service = await this.getService()
        await service.updatePowerMeterPoint(this.node)
    }
}